export const classes = {
  wrapper: 'flex',
  hours: 'ml-4',
  minutes: 'mr-4',
};
